"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var _ = require("lodash");
var moment = require("moment");
var google_map_react_1 = require("google-map-react");
var points_cluster_1 = require("points-cluster");
var constants_1 = require("../../../constants");
var Constants_1 = require("./Constants");
var MapComponent_1 = require("./MapComponent");
var Markers_1 = require("./Markers");
var utils_1 = require("../utils");
var Map = /** @class */ (function (_super) {
    __extends(Map, _super);
    function Map(props) {
        var _this = _super.call(this, props) || this;
        _this.decodePolyline = function (encoded) {
            if (!encoded) {
                return [];
            }
            var poly = [];
            var index = 0;
            var len = encoded.length;
            var lat = 0;
            var lng = 0;
            while (index < len) {
                var b = void 0;
                var shift = 0;
                var result = 0;
                do {
                    b = encoded.charCodeAt(index++) - 63;
                    // eslint-disable-next-line no-bitwise
                    result = result | ((b & 0x1f) << shift);
                    shift += 5;
                } while (b >= 0x20);
                // eslint-disable-next-line no-bitwise
                var dlat = (result & 1) !== 0 ? ~(result >> 1) : (result >> 1);
                lat += dlat;
                shift = 0;
                result = 0;
                do {
                    b = encoded.charCodeAt(index++) - 63;
                    // eslint-disable-next-line no-bitwise
                    result = result | ((b & 0x1f) << shift);
                    shift += 5;
                } while (b >= 0x20);
                // eslint-disable-next-line no-bitwise
                var dlng = (result & 1) !== 0 ? ~(result >> 1) : (result >> 1);
                lng += dlng;
                var p = {
                    latitude: lat / 1e5,
                    longitude: lng / 1e5,
                };
                poly.push(p);
            }
            return poly;
        };
        _this.state = Constants_1.mapInitialState;
        _this.polylines = [];
        return _this;
    }
    Map.prototype.buildDirectionArrow = function () {
        return {
            repeat: '50px',
            icon: {
                path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                scale: 1,
                fillOpacity: 0,
                strokeColor: Constants_1.COLORS.arrowColor,
                strokeWeight: 1,
                strokeOpacity: 1,
            },
        };
    };
    Map.prototype.buildPolyLine = function (strokeColor) {
        return new google.maps.Polyline({
            map: this.gmap,
            zIndex: 1,
            geodesic: true,
            strokeColor: strokeColor,
            strokeOpacity: 1,
            strokeWeight: 8,
            icons: [this.buildDirectionArrow()],
        });
    };
    Map.prototype.buildDisconnectedPolyLine = function () {
        return new google.maps.Polyline({
            map: this.gmap,
            zIndex: 1,
            strokeColor: Constants_1.COLORS.notConnectedPathColor,
            strokeWeight: 6,
            strokeOpacity: 1,
            geodesic: true,
            icons: [this.buildDirectionArrow()],
        });
    };
    Map.prototype.componentWillReceiveProps = function (newProps) {
        this.fitBounds();
    };
    Map.prototype.clearLocations = function () {
        _super.prototype.clearLocations.call(this);
        this.polylines.forEach(function (polyline) { return polyline.setMap(null); });
        this.polylines = [];
    };
    Map.prototype.drawPath = function () {
        var _this = this;
        var travelActivities = _.filter(this.props.activities, function (activity) {
            return activity.type === 'travel' || activity.type === 'workTravel';
        });
        var lastPoint = null;
        travelActivities.forEach(function (activity, index) {
            if (lastPoint) {
                var lineBetweenActivities = _this.buildDisconnectedPolyLine();
                var firstPoint = _.first(activity.path);
                lineBetweenActivities.getPath().push(new google.maps.LatLng(lastPoint.lat, lastPoint.lng));
                lineBetweenActivities.getPath().push(new google.maps.LatLng(firstPoint.lat, firstPoint.lng));
                _this.polylines.push(lineBetweenActivities);
                lastPoint = null;
            }
            if (!activity.polylines || !activity.polylines.length) {
                var pathPolyline_1 = _this.buildPolyLine(activity.color);
                _.forEach(activity.path, function (point) {
                    pathPolyline_1.getPath().push(new google.maps.LatLng(point.lat, point.lng));
                });
                lastPoint = _.last(activity.path);
                _this.polylines.push(pathPolyline_1);
                return;
            }
            var _loop_1 = function (polyline) {
                if (!polyline) {
                    return "continue";
                }
                var decodedPath = _this.decodePolyline(polyline);
                var pathPolyline = _this.buildPolyLine(activity.color);
                _.forEach(decodedPath, function (point) {
                    pathPolyline.getPath().push(new google.maps.LatLng(point.latitude, point.longitude));
                });
                lastPoint = _.last(activity.path);
                _this.polylines.push(pathPolyline);
            };
            for (var _i = 0, _a = activity.polylines; _i < _a.length; _i++) {
                var polyline = _a[_i];
                _loop_1(polyline);
            }
        });
    };
    Map.prototype.getProject = function (projectId) {
        return _.find(this.props.projects, function (project) { return project._id === projectId; });
    };
    Map.prototype.getMarkers = function () {
        var _this = this;
        /***
         * @description Since we draw displayable Activities(START, END, WORK) as markers on the map,
         * the first convert every activity to Marker and push it to result list.
         * @return Marker []
         ***/
        var activities = _.filter(this.props.activities, function (activity) {
            return _.includes(utils_1.DISPLAYABLE_ACTIVITY_TYPES, activity.type);
        });
        var getMarkerOptions = function (activity) {
            return {
                type: activity.type,
                lat: activity.lat,
                lng: activity.lng,
                endTime: moment(activity.end_time).format('HH:mm'),
                startTime: moment(activity.start_time).format('HH:mm'),
            };
        };
        var pointActivity2Marker = function (activity) {
            return __assign({}, getMarkerOptions(activity));
        };
        var workActivity2Marker = function (activity) {
            var project = _this.getProject(activity.project);
            var address = project.addresses.find(function (addr) {
                return addr._id === activity.address;
            }) || project.addresses[0];
            if (!address || !address.coords || !Array.isArray(address.coords)) {
                return null;
            }
            return __assign(__assign({}, getMarkerOptions(activity)), { project: project, lat: address.coords[1], lng: address.coords[0] });
        };
        return _.reduce(activities, function (markers, activity) {
            switch (activity.type) {
                case 'start': {
                    markers.push(pointActivity2Marker(activity));
                    break;
                }
                case 'work': {
                    var marker = workActivity2Marker(activity);
                    if (marker) {
                        markers.push(marker);
                    }
                    break;
                }
                case 'end': {
                    markers.push(pointActivity2Marker(activity));
                    break;
                }
                default: break;
            }
            return markers;
        }, []);
    };
    Map.prototype.buildCluster = function (cluster) {
        var _this = this;
        var buildMarker = function (marker) {
            // DISPLAYABLE_ACTIVITY_TYPES
            var drawableMarker;
            switch (marker.type) {
                case 'start':
                    drawableMarker = new Markers_1.PointMarker(__assign({}, marker));
                    return _this.drawPointMarker(drawableMarker);
                case 'end':
                    drawableMarker = new Markers_1.PointMarker(__assign({}, marker));
                    return _this.drawPointMarker(drawableMarker);
                case 'work':
                    drawableMarker = new Markers_1.WorkMarker(__assign({}, marker));
                    return _this.drawWorkMarker(drawableMarker);
                default: break;
            }
        };
        // Since cluster consists of only one Marker
        if (cluster.numPoints === 1) {
            return buildMarker(cluster.points[0]);
        }
        return this.drawCluster(new Markers_1.ClusterMarker(__assign({}, cluster)));
    };
    Map.prototype.drawObjects = function () {
        var _this = this;
        if (!this.gMapProps) {
            return;
        }
        var markers = this.getMarkers();
        var getClusters = (0, points_cluster_1.default)(markers, { minZoom: 1, maxZoom: 20, radius: 60 });
        var clusters = getClusters(this.gMapProps);
        clusters.forEach(function (cluster) { return _this.buildCluster(cluster); });
    };
    Map.prototype.renderLocations = function () {
        this.clearLocations();
        this.drawPath();
        this.drawObjects();
    };
    Map.prototype.getBoundsCoords = function () {
        /***
         * @description Map bounds are depend on the Start, End Activities points and projects locations
         * @return BoundCoord[]
         */
        var _this = this;
        var getProjectCoords = function (projectId, addressId) {
            /***
             * @param ProjectId
             * @param AddressId
             * @description Resolve the address the activity's work marker is drawn at (same resolution
             * as workActivity2Marker in getMarkers), so the bounds only contain drawn markers.
             * A project's addresses also include all complex sibling addresses, some of which carry
             * placeholder coordinates far away from the actual work location.
             * @return ICoordinate[]
             */
            var coords = [];
            var project = _.find(_this.props.projects, function (project) { return project._id === projectId; });
            if (!project || !project.addresses || !project.addresses.length) {
                return coords;
            }
            var address = project.addresses.find(function (addr) { return addr._id === addressId; }) || project.addresses[0];
            if (address && address.coords && Array.isArray(address.coords) && address.coords[0] !== 0 && address.coords[1] !== 0) {
                coords.push({ lat: address.coords[1], lng: address.coords[0] });
            }
            return coords;
        };
        var boundsCoords = [];
        _.forEach(this.props.activities, function (activity) {
            if (activity.type === 'start' || activity.type === 'end') {
                boundsCoords.push({ lat: activity.lat, lng: activity.lng });
            }
            if (activity.type === 'work') {
                boundsCoords.push.apply(boundsCoords, getProjectCoords(activity.project, activity.address));
            }
        });
        return boundsCoords;
    };
    Map.prototype.onMapLoaded = function (event) {
        var _this = this;
        this.gmap = event.map;
        this.safely(function () {
            _this.fitBounds();
            _this.drawPath();
            _this.drawObjects();
        });
    };
    /**
     * Drawing depends on the Google Maps JS API actually being usable, which is
     * not guaranteed: the API key is restricted by domain, so on any host it does
     * not cover (localhost, a preview deploy) the library loads but its
     * constructors throw. That used to escape out of render() and take the whole
     * hours page down through the ErrorBoundary — a blank screen instead of the
     * worklogs, because of a third-party script. Degrade to a map without
     * overlays instead.
     */
    Map.prototype.safely = function (draw) {
        try {
            draw();
        }
        catch (e) {
            console.error('Kaartlagen konden niet worden getekend:', e);
        }
    };
    Map.prototype.render = function () {
        var _this = this;
        if (this.gmap) {
            this.safely(function () { return _this.renderLocations(); });
        }
        return (React.createElement("div", { className: "map" },
            React.createElement(google_map_react_1.default, { bootstrapURLKeys: { key: constants_1.GOOGLE_API }, onChange: function (map) { return _this.onChange(map); }, center: this.state.center, zoom: this.state.zoom, onGoogleApiLoaded: function (event) { return _this.onMapLoaded(event); } })));
    };
    return Map;
}(MapComponent_1.MapComponent));
exports.default = Map;
